
import {createContext, useState} from 'react'

const Context = createContext()

export const CenterContextProvider = ({children}) => {
 const [allCenters, setAllCenters] = useState([]);
 const [centers, setCenters] = useState([]);
 const [center, setCenter] = useState({})
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState({
  message: '',
  status: 200
 })
 return <Context.Provider value={{allCenters, setAllCenters, centers, setCenters, center, setCenter, message, setMessage, loading, setLoading}}>
  {children}
 </Context.Provider>
}
export default Context